module.exports = __webpack_public_path__ + "static/media/map-full.6fb4272f.png";